<template>
  <div id="managementStatus">
    <div class="public-content">
      <div class="form-item-public">
        <el-form inline label-position="left">
          <el-form-item label='经营状况表'>
            <el-date-picker v-model="form.year" style='width: 140px;' type="year" size="mini" class="year-editor"
              placeholder="选择年" :clearable="false" :picker-options="pickerBeginDateBefore" @change="handleYearChange">
            </el-date-picker>
          </el-form-item>
          <el-form-item class='right-position'>
            <div class="right__position__btnWrap">
              <div v-for="btn in btnList" :key='btn.id'>
                <print-operation v-if="btn.permission == 'ac:stateOfBusiness:print'" :formData="printForm"
                  :showContinuit="false"></print-operation>
                <el-button v-if="btn.permission == 'ac:stateOfBusiness:export'" size="mini"
                  @click="exportTable">导出</el-button>
              </div>
            </div>

          </el-form-item>
        </el-form>
      </div>
      <public-table :table='tableData'></public-table>
    </div>
  </div>
</template>
<script>
import publicTable from '@/components/publicTable'
import { currencys } from '@/assets/utils/currencyFormat'
import printOperation from '@/components/print'
import { findPermission } from "@/api"
export default {
  components: {
    publicTable,
    printOperation
  },
  data() {
    return {
      isFirstActive: false,
      btnKey: "ac:stateOfBusiness:print,ac:stateOfBusiness:export",
      btnList: [],
      printForm: {        // 打印参数
        data: {
          year: ''
        },
        url: '/createPDF/printstateOfBusiness',
        continuityUrl: '/createPDF/printstateOfBusiness'
      },
      pickerBeginDateBefore: {
        disabledDate: (time) => {
          let beginStartDateVal = this.form.defaultStartDate;
          let beginEndDateVal = this.form.defaultEndDate;
          if (beginEndDateVal && beginEndDateVal) {
            return time.getTime() > beginEndDateVal || time.getTime() < beginStartDateVal
          }
        }
      },
      tableData: {
        border: true,				// 是否带有纵向边框
        stripe: true,				// 是否带有斑马纹
        loading: false,				// 是否显示加载动画
        hasSelect: false,			// 是否显示多选
        hasOperation: false,		// 是否有操作功能
        hasContextmenu: false,		// 是否有右键功能
        hasShowSummary: false,		// 是否显示合计行
        hasShowPagination: false,	// 是否显示分页
        config: [{
          label: '月份',
          value: 'month',
          show: 'normal'
        }, {
          label: '主营收入',
          value: 'mainRevenue',
          show: 'normal',
          formatter: this.formatter,
        }, {
          label: '主营成本',
          formatter: this.formatter,
          value: 'mainOperatingCosts',
          show: 'normal',
        }, {
          label: '期间费用',
          formatter: this.formatter,
          value: 'periodExpenses',
          show: 'normal',
        }, {
          label: '各项税金',
          formatter: this.formatter,
          value: 'variousTaxes',
          show: 'normal',
        }, {
          label: '其他支出',
          formatter: this.formatter,
          value: 'otherExpenses',
          show: 'normal',
        }, {
          label: '利润',
          formatter: this.formatter,
          value: 'profit',
          show: 'normal',
        }, {
          label: '毛利率',
          value: 'grossProfitMargin',
          show: 'normal',
        }, {
          label: '费用率',
          value: 'costRate',
          show: 'normal',
        }, {
          label: '税负率',
          value: 'taxBurdenRate',
          show: 'normal',
        }
        ],
        data: [],
        page: {
          pageNo: 1,
          pageSize: 20,
          count: 10
        },
        center: {
          textAlign: 'center',
          padding: '6px 0'
        },
        tableRowClassName: this.tableRowClassName
        // getSummaries: this.getSummaries,			// 自定义合计方法

      },
      form: {
        year: '',
        defaultStartDate: '',
        defaultEndDate: ''
      },
      nowYear: '',
    }
  },
  created() {
    this.getAccountPeriods();
    this.handleFindPermission();
  },
  mounted() {
  },
  computed: {
    getAccountPeriod() {
      let res = this.$store.state.accountInfo.yearPeriods;
      this.form.defaultStartDate = res.startTimeStamp;
      this.form.defaultEndDate = res.endTimeStamp;
      return res;
    },
    getClickCache() {
      return this.$store.state.loadstatus.isClickCache;
    },
  },
  activated() {
    if (this.getClickCache && this.isFirstActive) {
      this.getTableList();
    }
    this.isFirstActive = true;
  },
  methods: {
    exportTable() {
      const params = {
        cid: sessionStorage.cid,
        token: sessionStorage.token,
        year: new Date(this.form.year).getFullYear()
      }
      const router = this.$router.resolve({
        path: '/export/stateOfBusiness',
        query: params
      })
      window.open(this.$rootUrl + router.href, '_blank');
      this.$message.success(`经营状况表导出成功`)
    },
    async handleFindPermission() {
      const { data } = await findPermission({ permissions: this.btnKey })
      this.btnList = data.data || [];
    },
    // 行样式
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      if (row.month === "合计") {
        return "table_footer_color"
      }
    },
    // 自定义合计
    // getSummaries (param) {
    // 	const { columns, data } = param;
    // 	const sums = [];

    // 	columns.forEach((column, index) => {
    // 		if (index === 0) {
    // 			sums[index] = '合计';
    // 			return;
    // 		}
    // 		const values = data.map(item => {
    // 			return Number(item[column.property])
    // 		});

    // 		if (!values.every(value => {isNaN(value)})) {
    // 			sums[index] = values.reduce((prev, curr) => {
    // 				const value = Number(curr);
    // 				if(!isNaN(value)) {
    // 					prev = Number(prev)
    // 					if(!(parseFloat(prev)+parseFloat(curr))) {
    // 						return '';
    // 					}else {
    // 						return (parseFloat(prev)+parseFloat(curr)).toFixed(2);
    // 					}
    // 				} else {
    // 					return parseFloat(prev).toFixed(2);
    // 				}
    // 			}, 0);
    // 		} else {
    // 			sums[index] = '';
    // 		}
    // 	});
    // 	if(sums) {
    // 		return sums;
    // 	}else {
    // 		return '';
    // 	}
    // },
    // 表格格式化
    formatter(row, column, cellValue, index) {
      if (!row[column.property]) {
        return "0";
      } else {
        if(Number(row[column.property])) {
          return currencys(row[column.property]);
        }
        return row[column.property]
      }
    },
    // 获取会计期间/初始化数据
    getAccountPeriods() {
      let accountInfo = this.$getSessionStorage('accountInfo')
      if (!this.getAccountPeriod) {
        this.$store.dispatch('getAllYearPeriodsData')
      }
      this.form.year = accountInfo.yearPeriodTimeStamp;
      this.nowYear = this.$util.formatDate.format(accountInfo.yearPeriodTimeStamp, 'yyyy');
      this.getTableList();
    },
    // 选择期数
    handleYearChange(val) {
      this.nowYear = this.$util.formatDate.format(val, 'yyyy');
      this.getTableList();
    },
    // 获取经营状况表
    getTableList() {
      let params = {
        year: this.nowYear,
      }
      try {
        this.tableData.loading = true;
        this.printForm.data = params;
        this.$http.post('reportform/stateOfBusiness', params).then(res => {
          this.tableData.loading = false;
          if (res && res.data.code == 1) {
            this.tableData.data = res.data.data;
            // this.tableData.data.forEach(item=>{
            // 	for (const i in item) {
            // 		if (typeof item[i] === 'number') {
            // 			item[i] = item[i] == 0 ? '0' : item[i];
            // 		}
            // 	}
            // })
          }
        })
      } catch (e) {
        this.tableData.loading = false;
      }
    },
  },
  mounted() {

  }
}
</script>
<style lang='less' scoped>
#managementStatus {
  .right__position__btnWrap {
    display: flex;
  }

  .el-year-table td.today .cell {
    font-weight: 100;
    color: #606266;
  }

  .el-year-table td.disabled .cell {
    font-weight: 100;
    color: #C0C4CC;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/reportForm/managementStatus.vue